export enum FontFamilies {
  Inter = '"Inter",sans-serif',
  Roboto = '"Roboto",sans-serif',
}

export enum Colors {
  yellow1 = '#feda00',
  yellow2 = '#ffe233',
  yellow3 = '#f5d200',

  gray1 = '#383733',
  gray2 = '#858479',
  gray3 = '#d8d7cf',
  gray4 = '#eaeae6',
  gray5 = '#f5f5f4',
  gray6 = '#DFDFD7',
  gray7 = '#F8F8F8',

  red1 = '#ce4848',
  red2 = '#e17777',
  red3 = '#F3C3C3',
  red4 = '#FFAAAA',
  red5 = '#F9A6A6',

  green = '#AFE4C5',
  orange = '#F9DDBD',
  orange2 = '#EDC292',
  blue = '#B9E4F1',

  hover_links = '#665800',
  background = '#f5f5f4',
  modal_background = '#1D1D1D80',
  card = '#fdfdfc',
  white = '#ffffff',
  label_color = '#9b51e0',
}

export enum Filters {
  green = 'invert(91%) sepia(14%) saturate(540%) hue-rotate(87deg) brightness(93%) contrast(93%)',
  red = 'invert(78%) sepia(21%) saturate(347%) hue-rotate(314deg) brightness(104%) contrast(91%)',
  orange = 'invert(131%) sepia(76%) saturate(982%) hue-rotate(311deg) brightness(120%) contrast(105%)',
  blue = 'invert(116%) sepia(14%) saturate(5749%) hue-rotate(179deg) brightness(120%) contrast(89%)',
  red1 = 'invert(60%) sepia(58%) saturate(6243%) hue-rotate(333deg) brightness(87%) contrast(83%);',
}

export enum Media {
  mobile = '(min-width: 360px)', // ? consider to use 320px & refactor all the components
  tablet = '(min-width: 768px)',
  notebook = '(min-width: 1366px)',
  desktop = '(min-width: 1920px)',
}

export enum TextStylesMobile {
  h1 = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 600;  font-size: 24px;',
  h2 = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 500;  font-size: 20px;',
  h3 = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 500;  font-size: 18px;',
  h4 = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 600;  font-size: 16px;',
  button = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 500;  font-size: 16px;',
  body = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 400;  font-size: 14px;',
  small1 = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 400;  font-size: 12px;',
  small2 = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 500;  font-size: 12px;',
}
export enum TextStylesDesktop {
  h1 = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 600;  font-size: 40px;',
  h2 = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 500;  font-size: 32px;',
  h3 = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 500;  font-size: 28px;',
  h4 = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 600;  font-size: 20px;',
  button = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 500;  font-size: 18px;',
  body = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 400;  font-size: 16px;',
  small1 = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 400;  font-size: 14px;',
  small2 = 'font-family: "Inter", sans-serif;  font-style: normal;  font-weight: 500;  font-size: 14px;',
}

export enum Shadows {
  lightShadow = '0px 4px 15px 4px rgba(56, 55, 51, 0.03)',
  darkShadow = '0px 4px 15px 4px rgba(0, 0, 0, 0.08)',
}

export enum IconsSizes {
  S = '20px',
  M = '24px',
  L = '32px',
}

export enum FiltersTextBtn {
  gray2 = 'invert(51%) sepia(16%) saturate(183%) hue-rotate(17deg) brightness(97%) contrast(86%)',
  gray1 = 'invert(20%) sepia(7%) saturate(451%) hue-rotate(11deg) brightness(91%) contrast(89%)',
  yellow1 = 'invert(87%) sepia(25%) saturate(4485%) hue-rotate(0deg) brightness(106%) contrast(104%)',
  gray4 = 'invert(96%) sepia(4%) saturate(621%) hue-rotate(29deg) brightness(110%) contrast(84%)',
}
